import { render } from "./ProfileSettingsForm.vue?vue&type=template&id=1cbeac02&scoped=true"
import script from "./ProfileSettingsForm.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsForm.vue?vue&type=script&lang=js"

import "./ProfileSettingsForm.vue?vue&type=style&index=0&id=1cbeac02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbeac02"]])

export default __exports__